/**
 * [INPUT]: 无（model 路径按 window.location.hostname 运行时判定）
 * [OUTPUT]: 对外提供 PIPELINE_CONFIG（图像/人脸/姿态/质量/模型 路径与阈值）
 * [POS]: apps/web/pipeline 的可调参数中心，对齐 docs §4.2 拒绝条件、§4.1 加载策略；调参不改逻辑
 * [PROTOCOL]: 变更时更新此头部，然后检查 ../../CLAUDE.md
 *
 * 模型/WASM 来源按 origin 切换：生产域（pslanalyzer.com / www / 项目默认 pages.dev）走 Cloudflare R2，
 * 仅 localhost dev 回退到本地 .task + jsDelivr WASM，避免跨域拦截。
 * R2 CORS 须放行 pslanalyzer.com、www.pslanalyzer.com 与项目 pages.dev 域（见 docs §4.1）。
 */

/** 项目默认 Pages 域（deploy.sh DEFAULT_PROJECT_NAME=psl-analyzer-web）；预览部署形如 <branch>-psl-analyzer-web.pages.dev。 */
const PAGES_DEV_HOST = 'psl-analyzer-web.pages.dev'

/** 生产域判定：自定义域 + 项目 pages.dev（含预览部署）走 R2；仅 localhost dev 回退本地/CDN。 */
const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
const isProductionOrigin =
  hostname === 'pslanalyzer.com' ||
  hostname === 'www.pslanalyzer.com' ||
  hostname === PAGES_DEV_HOST ||
  hostname.endsWith(`-${PAGES_DEV_HOST}`)

export const PIPELINE_CONFIG = {
  image: {
    maxBytes: 10 * 1024 * 1024, // 10MB
    longestEdge: 1024,
    acceptedMime: ['image/jpeg', 'image/png', 'image/webp'] as const,
  },
  face: {
    minWidthRatio: 0.08, // 框宽 < 图宽 8% → 拒绝，对自拍更友好
    maxFaces: 1,
  },
  // 姿态阈值（度）。yaw/pitch 取自 MediaPipe 变换矩阵（solvePnP），roll 取自关键点。初始按 docs §4.2。
  // pitch 暂放宽至 25°：矩阵偶有噪声/真脸轻微俯仰，避免误杀正脸。矩阵轴/符号标定后可收回。
  pose: { yaw: 15, pitch: 25, roll: 10 },
  quality: {
    blurLaplacianVar: 60, // Laplacian 方差低于此判模糊（需样例集校准）
    brightnessMin: 50,
    brightnessMax: 210,
    brightnessVarMin: 12,
  },
  model: isProductionOrigin
    ? {
        // 生产：模型与 WASM 运行时均走 Cloudflare R2 自有域名（CORS 放行 pslanalyzer.com / www / pages.dev）
        landmarkerUrl: 'https://res.pslanalyzer.com/model/moduledata.bin',
        wasmUrl: 'https://res.pslanalyzer.com/wasm',
      }
    : {
        // dev（localhost）：本地 .task（public/models，同源无 CORS）+ jsDelivr WASM（公共 CDN，CORS=*）
        landmarkerUrl: '/models/mediapipe/face_landmarker.task',
        wasmUrl: 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm',
      },
} as const